import { render, staticRenderFns } from "./Beneficios.vue?vue&type=template&id=dcbe97ba&scoped=true&"
import script from "./Beneficios.vue?vue&type=script&lang=ts&"
export * from "./Beneficios.vue?vue&type=script&lang=ts&"
import style0 from "./Beneficios.vue?vue&type=style&index=0&id=dcbe97ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcbe97ba",
  null
  
)

export default component.exports